import modelEnhance from '@/utils/modelEnhance';

import { list, search, status, deleteAction } from '../service';

export default modelEnhance({
    namespace: 'page',
    state: {
        pageList: {}
    },
    subscriptions: {
        setup({ dispatch, history }) {
            return history.listen(({ pathname, query }) => {
                if (pathname.indexOf('/speed/page') > -1) {

                    dispatch({
                        type: 'getList', payload: {
                            host: pathname.split('/')[3]
                        }
                    });
                }
            });
        }
    },
    effects: {
        *getList({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(list, payload);

                if (code) return false;

                yield put({
                    type: 'setList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        },
        *searchUrl({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(search, payload);

                if (code) return false;

                yield put({
                    type: 'setList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        },
        *changeStatus({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(status, payload);

                if (code) return false;

                yield put({
                    type: 'modifyPage',
                    payload: payload
                });

                return true;

            } catch (e) {
                console.log(e);

                return false;
            }
        },
        *deletePage({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(deleteAction, payload);

                if (code) return false;

                yield put({
                    type: 'removePage',
                    payload: payload
                });

                return true;

            } catch (e) {
                console.log(e);

                return false;
            }
        }
    },
    reducers: {
        setList(state, { payload }) {
            return {
                ...state,
                pageList: payload
            };
        },
        modifyPage(state, { payload }) {

            let list = state.pageList.list;

            list = list.map((item) => {

                if (item._id == payload._id) {

                    return {
                        ...item,
                        ...payload
                    }
                }
                return item;
            });

            return {
                ...state,
                pageList: {
                    list: [...list]
                }
            };
        },
        removePage(state, { payload }) {

            let list = state.pageList.list

            list = list.filter((item) => {

                return item._id != payload._id;
            });

            return {
                ...state,
                pageList: {
                    list: [...list]
                }
            };
        },
    }
});